<template>
  <v-container class="c-audioguide" fluid grid-list-md>
    <v-layout row wrap>
      <v-flex xs6 v-for="(guide, index) in guides" :key="index">
        <v-btn
          style="height: auto; min-width: 0; width: 100%; margin: 0"
          color="#fff"
          class="px-1 py-1 c-audioguide__btn"
          large
          depressed
          @click="playGuide(guide)"
        >
          <img v-if="guide.icon" :src="guide.icon" :alt="guide.title" :title="guide.title" style="max-width: 100%" />
          <template v-else>
            {{ guide.title }}
          </template>
        </v-btn>
      </v-flex>
    </v-layout>
    <v-bottom-sheet v-model="showPlayer" inset>
      <player ref="player" @ended="() => showPlayer = false" />
    </v-bottom-sheet>
  </v-container>
</template>

<script>
import Player from './Player.vue';

export default {

  name: 'Audioguide',

  components: {
    Player,
  },

  props: {
    guides: {
      type: Array,
      default: () => [],
    },
  },

  data() {
    return {
      showPlayer: false,
    };
  },

  watch: {
    showPlayer(val) {
      if (!val) this.$refs.player.stop();
    },
  },

  methods: {
    playGuide(guide) {
      this.$refs.player.play(guide);
      this.showPlayer = true;
    },
  },

};
</script>

<style lang="scss">
  .c-audioguide {
    padding: 0;

    &__btn {
      background-color: transparent!important;
      // color: #D0DFFE !important;
      font-family: 'Delius';
      font-size: 45px !important;
      font-weight: 400;
      line-height: 48px !important;
    }
  }
</style>
